import React, { useCallback, useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
} from "react-bootstrap";
import { NewsFeed, svg } from "../../config/imagesLink";
import { toast } from "react-hot-toast";
import { Form, Link, useLocation } from "react-router-dom";
import axios from "../../API/axios";
import {
  checkConnection,
  invalidateCheckConnection,
} from "../../Services/apiService";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Select from "react-select";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import PostUpdate from "./PostUpdate";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import ReportGmailerrorredSharpIcon from "@mui/icons-material/ReportGmailerrorredSharp";
import PersonOffSharpIcon from "@mui/icons-material/PersonOffSharp";
import UpdateSharpIcon from "@mui/icons-material/UpdateSharp";
import HideSourceSharpIcon from "@mui/icons-material/HideSourceSharp";
import ContentCopySharpIcon from "@mui/icons-material/ContentCopySharp";

import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import ImageSharpIcon from "@mui/icons-material/ImageSharp";
import ArticleUpdate from "../Articles/ArticleUpdate";
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import {
  applyPostPinnedState,
  extractPostInfoFromGetPostResponse,
  isPostPinnedInStorage,
  readPinnedFlagFromPostInfo,
  resolveFeedPostPinnedState,
  setPostPinnedInStorage,
} from "../../utility/newsFeedPost";

const { pin } = svg;

const PostInteractionModal = ({
  postId,
  AllPostList,
  restrictedViewerToken,
  postList,
  setPage,
  setPostList,
  page,
  setTotalPages,
  totalPages,
  item,
  postOriginId,
  PostOriginType,
  setIsfollowed,
  setIsfollowedComp,
  isfollowedComp,
  isfollowed,
  isConnected,
  setIsConnected, 
  ispinned,
  setCompanyStats,
  setUserStat,
  connectionFromModal = false,
  onBeforePostDelete,

  // setShowDeletePost,
  // showDeletePost
}) => {
  console.log("postIdnewww", postId);
  const [showDeletePost, setShowDeletePost] = useState(false);
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const location = useLocation();
  const isNewsFeed = location.pathname === "/NewsFeed";
  // useEffect(() => {
  //   if (showDeletePost) {
  //     document.body.style.overflow = "hidden";
  //     document.documentElement.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "unset";
  //     document.documentElement.style.overflow = "";
  //   }
  // }, [showDeletePost]);
  const sessionId = localStorage.getItem("sessionId");
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [updateContent, setUpdateContent] = useState("");
  const [showModal, setShowModal] = useState(false);
  const inputFileRef = useRef(null);
  const userUid = localStorage.getItem("userUid");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const openModal = () => {
    setShowModal(true);
    console.log("ssssssss", showModal);
    
  };
  console.log("openModal", openModal);
  const closeModal = () => {
    setShowModal(false);
  };
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  //************************Delete Post start  ************************//

  const handleDeleteClose = () => {
    setShowDeletePost(false);
  };

  const deletePost = async () => {
    console.log('postIdnewww delete', item, postId);

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      langKey: language === "en" ? "" : language,

    }; 
    let res;
    try {
      res = await axios.post(`PostAction/DeletePost`, responseData);
    } catch (e) {
      if (e?.response?.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e?.response?.data?.message || "Something went wrong");
        setShowErrorToast(true);
      }
      return;
    }

    setToastMessage(res.data.message);
    setShowToast(true);

    if (typeof onBeforePostDelete === "function") {
      onBeforePostDelete(postId);
    }

    // Close delete modal before removing the post from the list.
    // Otherwise React unmounts the post card and the modal in the same commit,
    // which causes "removeChild" DOM errors in production builds.
    flushSync(() => {
      setShowDeletePost(false);
    });

    // Defer list removal so video/image media players finish DOM cleanup first.
    setTimeout(async () => {
      setPostList((prevPostList) => {
        const updatedList = prevPostList.filter(
          (post) => String(post?.postInfo?.postId) !== String(postId)
        );

        const newTotalPosts = updatedList.length;
        const newTotalPages = Math.ceil(newTotalPosts / 10);

        setTotalPages(newTotalPages);

        if (page > newTotalPages) {
          setPage(newTotalPages);
        }

        return updatedList;
      });

      try {
        if (page <= totalPages) {
          try {
            await AllPostList(page);
          } catch (err) {
            console.log("AllPostList failed silently");
          }
        }

        if (item?.postInfo?.postOriginType === "Company") {
          if (typeof setCompanyStats === "function") {
            setCompanyStats((prev) => ({
              ...prev,
              totalPosts: (prev?.totalPosts || 0) - 1
            }));
          }
        } else if (typeof setUserStat === "function") {
          setUserStat((prev) => ({
            ...prev,
            postsCount: (prev?.postsCount || 0) - 1
          }));
        }
      } catch (e) {
        console.log("Post delete UI sync warning:", e);
      }
    }, 0);
  };


   const [connectionCheck, setConnectionCheck] = useState("");
    console.log("connectionCheck", connectionCheck);
  
    const [connectionId, setConnectionId] = useState("");
    const connectionCheckInFlight = useRef(null);

    const applyConnectionCheckResult = (resData) => {
      if (resData?.status === "Warning") {
        setConnectionCheck(resData.responseData.value);
        setConnectionId(resData.responseData.id);
      }
    };

    const CheckConnectUser = async (id, { forceRefresh = false } = {}) => {
      const userUID = id || item?.postInfo?.userUid;
      if (!userUID) return;

      if (!forceRefresh && connectionCheckInFlight.current === userUID) {
        return;
      }
      connectionCheckInFlight.current = userUID;

      try {
        const resData = await checkConnection(userUID, { forceRefresh });
        console.log("checkFollowedUser", resData);
        applyConnectionCheckResult(resData);
      } catch (error) {
        console.log(error);
      } finally {
        if (connectionCheckInFlight.current === userUID) {
          connectionCheckInFlight.current = null;
        }
      }
    };

    useEffect(() => {
      const userUid = item?.postInfo?.userUid;
      const isUserPost = item?.postInfo?.postOriginType !== "Company";
      const connectionUnknown = item?.postInfo?.isConnectedByYou === null;
      const isFollowedByYou = item?.postInfo?.isFollowedByYou === true;

      if (!userUid || !isUserPost || !connectionUnknown || !isFollowedByYou) {
        return;
      }

      CheckConnectUser(userUid);
    }, [
      item?.postInfo?.userUid,
      item?.postInfo?.postOriginType,
      item?.postInfo?.isConnectedByYou,
      item?.postInfo?.isFollowedByYou,
    ]);


  //************************Delete Post End  ************************//

  //************************Repost Post start  ************************//
  const [reportPost, setReportPost] = useState(false);
  const [remark, setRemark] = useState("");
  const handlereportPost = () => {
    setReportPost(false);
  };

  const ReportPost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      remark: remark,
            langKey: language === "en" ? "" : language,

    };
    // console.log("postIdnewww", responseData);

    try {
      await axios.post(`PostAction/ReportPost`, responseData).then((res) => {
        setReportPost(!reportPost);
        setRemark("");
        // console.log("resData", res.data.message);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        AllPostList();
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Repost Post End  ************************//

  //************************Pin Post start  ************************//
  const pinSyncRef = useRef(false);
  const resolvedPinned = resolveFeedPostPinnedState(item);
  const [ispin, setIspin] = useState(resolvedPinned);

  const syncPinnedState = (pinned) => {
    setIspin(pinned);
    setPostPinnedInStorage(postId, pinned);
    if (typeof setPostList === "function") {
      setPostList((prev = []) => applyPostPinnedState(prev, postId, pinned));
    }
  };

  const isAlreadyPinnedError = (error) => {
    const message = String(
      error?.response?.data?.message || error?.message || ""
    ).toLowerCase();
    return message.includes("already pinned");
  };

  const syncPinStatusFromServer = async () => {
    if (!postId || item?.postInfo?.isOwned !== true) return;
    try {
      const token =
        restrictedViewerToken ||
        localStorage.getItem("restrictedViewerToken") ||
        "";
      const langKey = language === "en" ? "" : language;
      const res = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${token}&langKey=${langKey}`
      );
      const postInfo = extractPostInfoFromGetPostResponse(
        res?.data?.responseData
      );
      const pinnedFlag = readPinnedFlagFromPostInfo(postInfo);
      if (pinnedFlag !== null) {
        syncPinnedState(pinnedFlag);
      } else if (isPostPinnedInStorage(postId)) {
        syncPinnedState(true);
      }
    } catch (e) {
      // Keep local/storage state if GetPostInfo fails.
    }
  };

  useEffect(() => {
    if (item?.postInfo?.isOwned !== true || !postId || pinSyncRef.current) {
      return;
    }
    pinSyncRef.current = true;
    syncPinStatusFromServer();
  }, [postId, item?.postInfo?.isOwned]);

  const PinPost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      postOriginType: item?.postInfo?.postOriginType || PostOriginType,
      postOriginUID: item?.postInfo?.postOriginId || postOriginId,
      langKey: language === "en" ? "" : language,
    };
    try {
      const res = await axios.post(`PostAction/PinPost`, responseData);
      setToastMessage(res.data.message);
      setShowToast(true);
      syncPinnedState(true);
    } catch (e) {
      if (isAlreadyPinnedError(e)) {
        syncPinnedState(true);
        setToastMessage(
          e?.response?.data?.message || "Post already pinned!"
        );
        setShowToast(true);
        return;
      }
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message || e.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    setIspin(resolveFeedPostPinnedState(item));
  }, [
    postId,
    item?.postInfo?.isPinned,
    item?.postInfo?.isOwned,
    item?.postInfo?.postActionsInfo?.isPinned,
    item?.postInfo?.postActionsInfo?.pinned,
    item?.postInfo?.postActionsInfo?.isPin,
  ]);

  //************************Pin Post End  ************************//

  //************************Unpin Post start  ************************//
  const UnPinPost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      langKey: language === "en" ? "" : language,
    };
    try {
      const res = await axios.post(`PostAction/UnpinPost`, responseData);
      setToastMessage(res.data.message);
      setShowToast(true);
      syncPinnedState(false);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response?.data?.message || e.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Unpin Post End  ************************//

  //************************Hide Post start  ************************//
  const [isHidden, setIshidden] = useState(false);
  const hidePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
            langKey: language === "en" ? "" : language,

    };
    try {
      const res = await axios.post(`PostAction/HidePost`, responseData);
      // toast.success(res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true);
      // AllPostList();
      setPostList((prev) => prev.filter((post) => post?.postInfo?.postId !== postId));
      // setIshidden(true);
      // const postDetailsResponse = await axios.get(
      //   `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}`
      // );
      // const updatedPost = postDetailsResponse.data.responseData;
      // setPostList((prev) =>
      //   prev.map((post) =>
      //     post.postId === updatedPost.postId ? updatedPost : post
      //   )
      // );
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Hide Post End  ************************//

  //************************UnHide Post start  ************************//
  const UnhidePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`PostAction/UnhidePost`, responseData).then((res) => {
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        AllPostList();
        setPostList((prev) => prev.filter((post) => post?.postInfo?.postId !== postId));
        // setIshidden(false);
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************UnHide Post End  ************************//

  const [showPost, setShowPost] = useState(false);

  useEffect(() => {
    if (showPost && inputFileRef.current) {
      inputFileRef.current.click();
    }
  }, [showPost]);

  const copyPost = async () => {
    const copyData = {
      deviceType: "Web",
      id: postId,
      type: 1,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post("SMFeatures/SaveShareURL", copyData).then((res) => {
        console.log("res", res);

        navigator.clipboard.writeText(res.data.responseData.value);
        // toast.success('Link Copied')
        setToastMessage(res.data.message);
        setShowToast(true);
      });
    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  // console.log("item", item);

  const FollowUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: id,
            langKey: language === "en" ? "" : language,

    };
    try {
      const resData = await axios.post("UserFollow/FollowUser", data);
      // console.log("resDataaaaa", resData);
      setIsfollowed(true);
      setToastMessage(resData?.data?.message);
      setShowToast(true);
      // update newsfeed post list so UI stays in sync
      try {
        setPostList((prev = []) =>
          prev.map((p) =>
            p?.postInfo?.postId === postId || p?.postInfo?.userUid === id
              ? {
                  ...p,
                  postInfo: {
                    ...p.postInfo,
                    isFollowedByYou: true,
                  },
                }
              : p
          )
        );
      } catch (e) {
        // ignore
      }

      if (
        item?.postInfo?.postOriginType !== "Company" &&
        item?.postInfo?.isConnectedByYou === null
      ) {
        invalidateCheckConnection(id);
        CheckConnectUser(id, { forceRefresh: true });
      }
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const [showUnfollowModal, setShowUnfollowModal] = useState(false);
  const handleCloseUnfollowModal = () => setShowUnfollowModal(false);
  const handleShowunfollowModal = () => setShowUnfollowModal(true);

  const unFollowUser = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: item?.postInfo?.userUid,
            langKey: language === "en" ? "" : language,

    };
    try {
      const res = await axios.post(`UserFollow/UnfollowUser`, responseData);
      console.log("res", res);
      setIsfollowed(false);
      setToastMessage(res.data.message);
      setShowToast(true); 
      // setConnectionCheck("None");
 
      handleCloseUnfollowModal();
      // update newsfeed post list so UI stays in sync
      try {
        setPostList((prev = []) =>
          prev.map((p) =>
            p?.postInfo?.postId === postId || p?.postInfo?.userUid === item?.postInfo?.userUid
              ? {
                  ...p,
                  postInfo: {
                    ...p.postInfo,
                    isFollowedByYou: false,
                  },
                }
              : p
          )
        );
      } catch (e) {}
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ Follow Company  ************************//

  const FollowCompany = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      uiD_ID: id,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post("Entity/Follow/Company", data).then((resData) => {
        // CompanyDetails();
        setIsfollowedComp(true);
        setToastMessage(resData.data.message);
        setShowToast(true);
        // sync company follow in newsfeed
        try {
          setPostList((prev = []) =>
            prev.map((p) =>
              p?.postInfo?.postId === postId || p?.postInfo?.userUid === id
                ? {
                    ...p,
                    postInfo: {
                      ...p.postInfo,
                      isFollowedByYou: true,
                    },
                  }
                : p
            )
          );
        } catch (e) {}
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ UnFollow Company  ************************//

  const UnFollowCompany = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      uiD_ID: item?.postInfo?.userUid,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post("Entity/Unfollow/Company", data).then((resData) => {
        // CompanyDetails();
        setToastMessage(resData.data.message);
        setShowToast(true);
        setIsfollowedComp(false);
        handleCloseUnfollowModal();
         // sync company unfollow in newsfeed
         try {
           setPostList((prev = []) =>
             prev.map((p) =>
               p?.postInfo?.postId === postId || p?.postInfo?.userUid === item?.postInfo?.userUid
                 ? {
                     ...p,
                     postInfo: {
                       ...p.postInfo,
                       isFollowedByYou: false,
                     },
                   }
                 : p
             )
           );
         } catch (e) {}
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  // useEffect(() => {
  //   if (reportPost || showUnfollowModal) {
  //     document.body.style.overflow = "hidden";
  //     document.documentElement.style.overflow = "hidden";
  //     document.body.classList.add("modal-open"); // When a modal opens
  //   } else {
  //     document.body.style.overflow = "unset";
  //     document.documentElement.style.overflow = "";
  //     document.body.classList.remove("modal-open"); // When a modal closes
  //   }
  // }, [reportPost, showUnfollowModal]);

  //************************Accept Request   ************************//
  const AcceptRequest = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: id,
      langKey: language === "en" ? "" : language,

    };
    console.log(data);
    try {
      await axios
        .post("Connection/SendConnectionRequest ", data)
        .then((resData) => {
          // console.log(resData.data.message);
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          // mark as request sent/connected in UI and sync newsfeed posts
          setIsConnected(true);
          setConnectionCheck("Sent");
          try {
            setPostList((prev = []) =>
              prev.map((p) =>
                p?.postInfo?.userUid === id
                  ? {
                      ...p,
                      postInfo: {
                        ...p.postInfo,
                        isConnectedByYou: true,
                      },
                    }
                  : p
              )
            );
          } catch (e) {}
          invalidateCheckConnection(id);
        });
      } catch (error) {
        if (error?.response && error?.response?.status === 404) {
          setWarningToastMessage(error?.response?.data?.message);
          setShowWarningToast(true);
        } else {
          console.log("wwwwwwwwww",error);
          
          setErrorToastMessage(error?.response?.data?.message);
          setShowErrorToast(true);
        }
      }
    };
    // console.log("connnectttt", isConnected);

  //************************Accept Request ************************//

  //************************Cancel Request   ************************//
  const [show, setShow] = useState(false);
  const [Uid, setUid] = useState(null);
  const cancelRequestClose = () => {
    setShow(false);
  };
  // const [skillId, setSkillId] = useState("");
  // const [userUID, setuserUID] = useState("");
  const CancelRequest = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: Uid,
            langKey: language === "en" ? "" : language,

    };
    console.log(data);
    try {
      await axios
        .post("Connection/CancelConnectionRequest ", data)
        .then((resData) => {
          console.log(resData);
          setShow(!show);
          //   toast.success(resData.data.message);
          setToastMessage(resData?.data?.message);
          setShowToast(true);
          setIsConnected(false)
          setConnectionCheck(null);
          setConnectionId(null);
          // sync newsfeed posts to reflect cancelled request
          try {
            setPostList((prev = []) =>
              prev.map((p) =>
                p?.postInfo?.userUid === Uid
                  ? {
                      ...p,
                      postInfo: {
                        ...p.postInfo,
                        isConnectedByYou: false,
                      },
                    }
                  : p
              )
            );
          } catch (e) {}
          invalidateCheckConnection(Uid);
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e?.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };
 //************************Disconnect Request   ************************//
   
 const [showModalDisC, setShowModalDisC] = useState(false);
  const handleShowModal = ( ) => {  
    setShowModalDisC(true);
  };

  const handleCloseModal = () => {
    setShowModalDisC(false); 
  };
  const DisconnectUser = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: item?.postInfo?.userUid,
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios.post("Connection/DisconnectUser ", data).then((resData) => {
        console.log(resData);
        // setShowModalDisC(!showModalDisC);
        //   toast.success(resData.data.message);
        setConnectionCheck(null); // 🔥 THIS IS KEY
        setConnectionId(null);
        setToastMessage(resData.data.message);
        setShowToast(true);
        // sync newsfeed posts to reflect disconnected state
        try {
          setPostList((prev = []) =>
            prev.map((p) =>
              p?.postInfo?.userUid === item?.postInfo?.userUid
                ? {
                    ...p,
                    postInfo: {
                      ...p.postInfo,
                      isConnectedByYou: false,
                    },
                  }
                : p
            )
          );
        } catch (e) {}
        invalidateCheckConnection(item?.postInfo?.userUid);
        handleCloseModal()
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Disconnect Request ************************//


  const isFollowed =
  isfollowed ||
  isfollowedComp ||
  item?.postInfo?.isFollowedByYou;

const isConnectedCheck = connectionCheck === "Connected";
const isRequestSent = connectionCheck === "Sent";
const isRequestReceived = connectionCheck === "Received"; 
  const isNoConnection =
  !connectionCheck || connectionCheck === "None";


  //************************Cancel Request ************************//

  const handlePostInteractionEscapeClose = useCallback(() => {
    if (showModal) return;
    if (showDeletePost) {
      handleDeleteClose();
    } else if (reportPost) {
      handlereportPost();
    } else if (showUnfollowModal) {
      handleCloseUnfollowModal();
    } else if (showModalDisC) {
      handleCloseModal();
    } else if (show) {
      cancelRequestClose();
    }
  }, [
    showModal,
    showDeletePost,
    reportPost,
    showUnfollowModal,
    showModalDisC,
    show,
    handleDeleteClose,
    handlereportPost,
    handleCloseUnfollowModal,
    handleCloseModal,
    cancelRequestClose,
  ]);

  useEscapeKeyDown(
    !showModal &&
      (showDeletePost ||
        reportPost ||
        showUnfollowModal ||
        showModalDisC ||
        show),
    handlePostInteractionEscapeClose
  );

  return (
    <>
      {/* {console.log("item22222222", item) } */}
      <div className="d-flex align-items-center">
        {ispin ? (
          <PushPinIcon className="material-symbols-sharp me-2 post-pin-icon" />
        ) : null}

        {/* follow post  */}

        {item?.postInfo?.isOwned === false ? (
          <>
          {isNewsFeed && !isConnected && (
            <>
              {/* FOLLOW */}
              {!isFollowed && (
                <div className="ms-auto"  onClick={() =>
                      item?.postInfo?.postOriginType === "Company"
                        ? FollowCompany(item?.postInfo?.userUid)
                        : FollowUser(item?.postInfo?.userUid)
                    }>
                  <button
                    className="mainBtn1 me-2 ms-2"
                    style={{ height: "30px" }}
                   
                  >
                    {t("Newsfeed.Follow")}
                  </button>
                </div>
              )}

              {/* CONNECT */}
              {isFollowed &&
                isNoConnection &&
                !item?.postInfo?.isConnectedByYou &&
                item?.postInfo?.postOriginType !== "Company" && (
                  <div className="ms-auto"  onClick={() =>
                        AcceptRequest(item?.postInfo?.userUid)
                      }>
                    <button
                      className="mainBtn1 me-2 ms-2"
                      style={{ height: "30px" }}
                     
                    >
                      {t("Recommendations.Connect")}
                    </button>
                  </div>
                )}
            </>
          )}

          </>
        ) : (
          ""
        )}

        <div
          className="postMenu pointer"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <MoreHorizSharpIcon className="material-symbols-sharp" />
          {showDropdown && (
            <Dropdown.Menu
              show={showDropdown}
              ref={dropdownRef}
              className="InteractionModal"
            >
              {item?.postInfo?.isOwned === false && (
                <>
                  {/* unfollow post  */}

                  {isFollowed && (
                    <Dropdown.Item as="button" className="dropdownList" 
                    onClick={() => {
                          handleShowunfollowModal();
                          toggleDropdown();
                        }}>
                      <div
                        
                      >
                        <div className="d-flex align-items-center">
                          <PersonOffSharpIcon className="me-2" />
                          <span className="dropdownTxt f-14">
                            {t("Newsfeed.Unfollow")}
                          </span>
                        </div>
                        <p className="f-12 dropdownPara">
                          {t("Newsfeed.Unfollow User")}
                        </p>
                      </div>
                    </Dropdown.Item>
                  )}

                    {isRequestSent &&
                     item?.postInfo?.postOriginType !== "Company" && (
                      <Dropdown.Item as="button" className="dropdownList"
                      onClick={() => {
                            setShow(true);
                            setUid(item?.postInfo?.userUid);
                          }}>
                        <div
                          
                        >
                          <div className="d-flex align-items-center">
                            <CancelOutlinedIcon className="me-2" />
                            <span className="dropdownTxt f-14">
                              {t("Recommendations.Cancel Request")}
                            </span>
                          </div>
                          <p className="f-12 dropdownPara">
                            {t("Recommendations.Cancel Request")}
                          </p>
                        </div>
                      </Dropdown.Item>
                    )}

                    {/* {isRequestReceived && (
                      <Dropdown.Item as="button" className="dropdownList">
                        <Link onClick={AcceptRequest}>
                          <div className="d-flex align-items-center">
                            <CheckOutlinedIcon className="me-2" />
                            <span className="dropdownTxt f-14">
                              {t("Connections.Accept")}
                            </span>
                          </div>
                        </Link>
                      </Dropdown.Item>
                    )} */}

                    {isConnected ||
                       item?.postInfo?.isConnectedByYou  === true && 
                       <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => {
                               handleShowModal();
                              }}>
                            <div
                             
                            >
                              <div className="d-flex align-items-center">
                                <PersonOffSharpIcon className="material-symbols-sharp me-2" />
                                <span className="dropdownTxt f-14">{t("Connections.Disconnect")}</span>
                              </div>
                              <p className="f-12 dropdownPara">  {t("Connections.Disconnect User")}</p>
                            </div>
                       </Dropdown.Item>
                  }

                  {/* report post  */}

                  <Dropdown.Item as="button" className="dropdownList"
                   onClick={() => {
                        setReportPost(!reportPost);
                      }}>
                    <div
                     
                    >
                      <div className="d-flex align-items-center">
                        <ReportGmailerrorredSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt f-14">{t("Newsfeed.Report Post")}</span>
                      </div>
                      <p className="f-12 dropdownPara">
                       {/* {t("Newsfeed.We won't let know")} {item?.postInfo?.userName}, {t("Newsfeed.who reported")}  */}
                        {t("Newsfeed.We won't let Welinkjobs.know who reported")}
                      </p>
                    </div>
                  </Dropdown.Item>
                </>
              )}

              {/* pin unpin post  */}

              {item?.postInfo?.isOwned === true && (
                <>
                  {ispin ? (
                    <Dropdown.Item as="button" className="dropdownList" 
                     onClick={() => {
                          UnPinPost();
                          toggleDropdown();
                        }}>
                      <div
                       
                      >
                        <div className="d-flex align-items-center">
                          <PushPinOutlinedIcon className="material-symbols-sharp me-2" />

                          {/* <img src={pin} /> */}
                          <span className="dropdownTxt f-14">{t("Newsfeed.Unpin")}</span>
                        </div>
                        <p className="f-12 dropdownPara">{t("Newsfeed.Unpin")}</p>
                      </div>
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item as="button" className="dropdownList"
                     onClick={() => {
                          PinPost();
                          toggleDropdown();
                        }}>
                      <div
                       
                      >
                        <div className="d-flex align-items-center">
                          {/* <img src={pin} /> */}
                          <PushPinIcon className="material-symbols-sharp me-2" />

                          <span className="dropdownTxt f-14">{t("Newsfeed.Pin Post")}</span>
                        </div>
                        <p className="f-12 dropdownPara">{t("Newsfeed.Pin Post")}</p>
                      </div>
                    </Dropdown.Item>
                  )}
                </>
              )}

              {/* Hide unhide post  */}

              {item?.postInfo?.isOwned === false && (
                <>
                    {item?.postInfo?.postActionsInfo?.isHidden === true ||
                      isHidden === true ? (
                      <Dropdown.Item as="button" className="dropdownList"
                       onClick={() => {
                            UnhidePost();
                            toggleDropdown();
                          }}>
                        <div
                         
                        >
                          <div className="d-flex align-items-center">
                            <HideSourceSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt f-14">{t("Newsfeed.UnHide Post")}</span>
                          </div>
                          <p className="f-12 dropdownPara">{t("Newsfeed.UnHide Post")}</p>
                        </div>
                      </Dropdown.Item>
                    ) : 
                    (
                      <Dropdown.Item as="button" className="dropdownList">
                        <div
                          onClick={() => {
                            hidePost();
                            toggleDropdown();
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <HideSourceSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt f-14">{t("Newsfeed.Hide Post")} </span>
                          </div>
                          <p className="f-12 dropdownPara">{t("Newsfeed.Hide Post")}</p>
                        </div>
                      </Dropdown.Item>
                    )
                    }
                </>
              )}

              {/* copy post  */}

              <Dropdown.Item as="button" className="dropdownList"
               onClick={() => {
                    copyPost();
                    toggleDropdown();
                  }}>
                <div
                 
                >
                  <div className="d-flex align-items-center">
                    <ContentCopySharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Newsfeed.Copy Link")}</span>
                  </div>
                  <p className="f-12 dropdownPara">{t("Newsfeed.Copy Post Link")}</p>
                </div>
              </Dropdown.Item>


              {item?.postInfo?.isOwned === true && (
                <>
                  {/* Update post  */}
                  <Dropdown.Item as="button" className="dropdownList d-block"
                   onClick={() => { 
                        setShowModal(true); 
                      }}>
                  
                    <div
                     
                    >
                      {/* <div className="update-post-cont"> */}
                      <div className="">
                        <UpdateSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt f-14">{t("Drafts.Update Post")}</span>
                      </div>
                      <p className="f-12 dropdownPara">{t("Drafts.Update Post")}</p>
                      {/* </div> */}
                    </div>
                  </Dropdown.Item>

                  {/* delete post  */}
                  <Dropdown.Item as="button" className="dropdownList"
                   onClick={() => {
                        setShowDeletePost(!showDeletePost);
                        toggleDropdown();
                      }}>
                    <div
                     
                    >
                      <div className="d-flex align-items-center">
                        <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt f-14">{t("Drafts.Delete")}</span>
                      </div>
                      <p className="f-12 dropdownPara">
                       {t("Drafts.Once Deleted it can't be recovered")}
                      </p>
                    </div>
                  </Dropdown.Item>

                </>
              )}

            </Dropdown.Menu>
          )}
        </div>
      </div>

      {showModalDisC && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                  {t("modals.Are you sure you want to Disconnect")}
                </h6>
 
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn "
                  onClick={() => DisconnectUser()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDeletePost && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => deletePost()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {reportPost && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                {/* <h4>Report Post</h4> */}
                <h6>{t("modals.Are you sure you want to Report this post?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handlereportPost();
                  }}
                />
              </div>

              <div className="lableStyle">
                <input
                  type="text"
                  placeholder={t("modals.Enter feedback here")}
                  required
                  value={remark}
                  style={{ width: "100%" }}
                  onChange={(e) => setRemark(e.target.value)}
                  className="report-people-post"
                />
              </div>

              <div className="col-md-12 text-end mt-4">
                <button type="button" className="mainBtn1" onClick={ReportPost}>
                  {t("Newsfeed.Report")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUnfollowModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                {/* <h6>Unfollow User</h6> */}
                <h6> {t("modals.Are you sure you want to unfollow")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseUnfollowModal();
                  }}
                />
              </div>

              <div className="col-md-12 text-end mt-4 d-flex justify-content-center">
                <button
                  type="button"
                  className="closebtn"
                  onClick={() => { item?.postInfo?.postOriginType === 'Company' 
                    ? UnFollowCompany() : unFollowUser() }}
                >
                  {t("Recommendations.Unfollow")}  
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal &&
        (item?.cntntTypCategory === "Article" ? (
          <ArticleUpdate
            showModal={showModal}
            closeModal={closeModal}
            articleSlug={item?.postInfo?.articleInfo?.titleSlug}
            articleId={item?.postInfo?.articleInfo?.articleId}
            postId={item?.postInfo?.postId}
            ImageUrl={item?.postInfo?.articleInfo?.bannerUrl}
            postList={postList}
            restrictedViewerToken={restrictedViewerToken}
            setPostList={setPostList}

          // onUpdateSuccess={onUpdateSuccess}
          />
        ) : (
          <PostUpdate
            postList={postList}
            openModal={openModal}
            closeModal={closeModal}
            showModal={showModal}
            item={item}
            PostOriginType={PostOriginType}
            postOriginId={postOriginId}
            setShowModal={setShowModal}
            postId={postId}
            setPostList={setPostList}
            AllPostList={AllPostList}
            restrictedViewerToken={restrictedViewerToken}

          />
        ))}

      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default PostInteractionModal;
